import faqReducer from './reducer';

export default faqReducer;

export {
  FETCH_FAQ_CATEGORIES_REQUEST,
  FETCH_FAQ_CATEGORIES_SUCCESS,
  FETCH_FAQ_CATEGORIES_FAILURE,
  fetchFaqCategoriesRequest,
  fetchFaqCategoriesSuccess,
  fetchFaqCategoriesFailure
} from './actions';

export {
  isFetchingFaqCategories,
  getFaqCategories,
  getFaqQuestion
} from './selectors';



// WEBPACK FOOTER //
// ./src/store/faq/index.js